import { render, staticRenderFns } from "./CustomDropdown.vue?vue&type=template&id=2841f7ec&scoped=true&"
import script from "./CustomDropdown.vue?vue&type=script&lang=js&"
export * from "./CustomDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2841f7ec",
  null
  
)

export default component.exports